/* Custom wishlist — localStorage based. Heart toggle on product cards, header count, wishlist page. */
(function () {
  var KEY = 'wishlist_v1';
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function escapeHtml(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function updateHearts() {
    var set = {};
    read().forEach(function (x) { set[x.handle] = 1; });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = !!set[btn.getAttribute('data-wishlist-handle')];
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  function updateCount() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function toggle(btn) {
    var h = btn.getAttribute('data-wishlist-handle');
    if (!h) return;
    var a = read();
    var i = -1;
    for (var k = 0; k < a.length; k++) { if (a[k].handle === h) { i = k; break; } }
    if (i > -1) {
      a.splice(i, 1);
    } else {
      a.push({
        handle: h,
        title: btn.getAttribute('data-wishlist-title') || '',
        url: btn.getAttribute('data-wishlist-url') || ('/products/' + h),
        image: btn.getAttribute('data-wishlist-image') || '',
        price: btn.getAttribute('data-wishlist-price') || ''
      });
    }
    write(a);
    updateHearts();
    updateCount();
    renderAll();
  }

  // Capture-phase so the heart/action clicks never trigger card links / quick-view.
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    // Header heart icon -> open the drawer instead of navigating to the page.
    var hdr = e.target.closest('[data-wishlist-header]');
    if (hdr) { e.preventDefault(); e.stopPropagation(); openDrawer(); return; }
    if (e.target.closest('[data-wishlist-close]') || (e.target.hasAttribute && e.target.hasAttribute('data-wishlist-overlay'))) {
      e.preventDefault(); closeDrawer(); return;
    }
    var rm = e.target.closest('[data-wishlist-toggle]');
    if (rm) { e.preventDefault(); e.stopPropagation(); toggle(rm); return; }
    var add = e.target.closest('[data-wishlist-add]');
    if (add) { e.preventDefault(); e.stopPropagation(); addToCart(add); return; }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  // Add a wishlist product to the cart (first available variant) and refresh the drawer.
  function addToCart(btn) {
    var handle = btn.getAttribute('data-wishlist-handle');
    if (!handle || btn.disabled) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (prod) {
        var v = (prod.variants || []).filter(function (x) { return x.available; })[0] || (prod.variants || [])[0];
        if (!v) throw new Error('no variant');
        var drawer = document.querySelector('cart-drawer, .cart-drawer, #CartDrawer');
        var section = drawer && drawer.closest ? drawer.closest('.shopify-section') : null;
        var sectionId = section ? section.id.replace('shopify-section-', '') : null;
        var body = { items: [{ id: v.id, quantity: 1 }] };
        if (sectionId) { body.sections = [sectionId]; body.sections_url = location.pathname; }
        return fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
        }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function (res) { return { res: res, sectionId: sectionId, drawer: drawer }; });
      })
      .then(function (d) {
        // Swap in the freshly rendered cart drawer, then open it.
        if (d.sectionId && d.res.sections && d.res.sections[d.sectionId] && d.drawer) {
          try {
            var doc = new DOMParser().parseFromString(d.res.sections[d.sectionId], 'text/html');
            var fresh = doc.querySelector('cart-drawer, .cart-drawer, #CartDrawer');
            if (fresh) d.drawer.replaceWith(fresh);
          } catch (e) {}
        }
        btn.textContent = 'Added ✓';
        closeDrawer();
        var toggle = document.querySelector('[data-cart-toggle], .cart__toggle');
        if (toggle) toggle.click();
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2000);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2000);
      });
  }

  function renderPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var a = read();
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!a.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    grid.innerHTML = a.map(function (x) {
      return '<div class="wishlist-card">' +
        '<a class="wishlist-card__link" href="' + encodeURI(x.url) + '">' +
        (x.image ? '<img class="wishlist-card__img" src="' + encodeURI(x.image) + '" alt="" loading="lazy">' : '') +
        '<div class="wishlist-card__title">' + escapeHtml(x.title) + '</div>' +
        '<div class="wishlist-card__price">' + escapeHtml(x.price) + '</div></a>' +
        '<div class="wishlist-card__actions">' +
        '<button type="button" class="wishlist-card__add" data-wishlist-add data-wishlist-handle="' + escapeHtml(x.handle) + '">Add to Cart</button>' +
        '<button type="button" class="wishlist-card__remove" data-wishlist-toggle data-wishlist-handle="' + escapeHtml(x.handle) + '" aria-label="Remove from wishlist">Remove</button>' +
        '</div></div>';
    }).join('');
  }

  var HEART = '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
  var CLOSE = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';

  /* ---- Slide-in wishlist drawer (replaces the standalone wishlist page) ---- */
  var drawerEl, overlayEl;
  function buildDrawer() {
    if (drawerEl) return;
    overlayEl = document.createElement('div');
    overlayEl.className = 'wishlist-drawer-overlay';
    overlayEl.setAttribute('data-wishlist-overlay', '');
    drawerEl = document.createElement('aside');
    drawerEl.className = 'wishlist-drawer';
    drawerEl.setAttribute('data-wishlist-drawer', '');
    drawerEl.setAttribute('role', 'dialog');
    drawerEl.setAttribute('aria-label', 'Wishlist');
    drawerEl.setAttribute('aria-hidden', 'true');
    drawerEl.innerHTML =
      '<div class="wishlist-drawer__header">' +
        '<span class="wishlist-drawer__title">Wishlist <span data-wishlist-drawer-count></span></span>' +
        '<button type="button" class="wishlist-drawer__close" data-wishlist-close aria-label="Close wishlist">' + CLOSE + '</button>' +
      '</div>' +
      '<div class="wishlist-drawer__body" data-wishlist-drawer-body></div>';
    document.body.appendChild(overlayEl);
    document.body.appendChild(drawerEl);
  }
  function renderDrawer() {
    if (!drawerEl) return;
    var a = read();
    var cnt = drawerEl.querySelector('[data-wishlist-drawer-count]');
    if (cnt) cnt.textContent = a.length ? '(' + a.length + ')' : '';
    var body = drawerEl.querySelector('[data-wishlist-drawer-body]');
    if (!a.length) {
      body.innerHTML = '<div class="wishlist-drawer__empty">Your wishlist is empty. Tap the heart on any product to save it here.</div>';
      return;
    }
    body.innerHTML = a.map(function (x) {
      return '<div class="wishlist-drawer__item">' +
        '<a class="wishlist-drawer__item-img" href="' + encodeURI(x.url) + '">' +
        (x.image ? '<img src="' + encodeURI(x.image) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="wishlist-drawer__item-info">' +
          '<a class="wishlist-drawer__item-title" href="' + encodeURI(x.url) + '">' + escapeHtml(x.title) + '</a>' +
          '<div class="wishlist-drawer__item-price">' + escapeHtml(x.price) + '</div>' +
          '<div class="wishlist-drawer__item-actions">' +
            '<button type="button" class="wishlist-drawer__add" data-wishlist-add data-wishlist-handle="' + escapeHtml(x.handle) + '">Add to Cart</button>' +
            '<button type="button" class="wishlist-drawer__remove" data-wishlist-toggle data-wishlist-handle="' + escapeHtml(x.handle) + '" aria-label="Remove from wishlist">Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
  }
  function renderAll() { renderPage(); renderDrawer(); }
  function openDrawer() {
    buildDrawer();
    renderDrawer();
    // Anchor the popup just below the (visible) wishlist icon and fit the viewport.
    var icon = [].slice.call(document.querySelectorAll('[data-wishlist-header]'))
      .filter(function (e) { return e.getBoundingClientRect().width > 0; })[0];
    var top = icon ? Math.round(icon.getBoundingClientRect().bottom) + 10 : 80;
    if (top < 10) top = 10;
    drawerEl.style.top = top + 'px';
    drawerEl.style.maxHeight = Math.max(220, window.innerHeight - top - 20) + 'px';
    // allow the element to be in the DOM before the transition
    requestAnimationFrame(function () {
      document.body.classList.add('wishlist-drawer-open');
      drawerEl.setAttribute('aria-hidden', 'false');
    });
  }
  function closeDrawer() {
    document.body.classList.remove('wishlist-drawer-open');
    if (drawerEl) drawerEl.setAttribute('aria-hidden', 'true');
  }

  function injectHeader() {
    // Themes render multiple header copies (desktop / mobile / sticky); add a heart
    // next to every cart link so whichever header is visible shows it.
    var carts = document.querySelectorAll('a[href$="/cart"]');
    carts.forEach(function (cart) {
      if (cart.getAttribute('data-wishlist-done')) return;
      if (!cart.parentNode) return;
      cart.setAttribute('data-wishlist-done', '1');
      var a = document.createElement('a');
      a.href = '/pages/wishlist';
      a.setAttribute('data-wishlist-header', '');
      a.setAttribute('aria-label', 'Wishlist');
      a.innerHTML = HEART + '<span class="wishlist-header__count" data-wishlist-count hidden>0</span>';
      var menuItem = cart.closest('.menu__item');
      if (menuItem && menuItem.parentNode) {
        // Desktop icon menu: mirror the theme's icon menu-item wrapper.
        a.className = 'wishlist-header';
        var wrap = document.createElement(menuItem.tagName.toLowerCase());
        wrap.className = menuItem.className;
        wrap.appendChild(a);
        menuItem.parentNode.insertBefore(wrap, menuItem);
      } else {
        // Inline icon row (e.g. mobile header): match the cart button's own
        // classes (minus cart-specific ones) and insert as a sibling before it.
        var cls = (cart.className || '').replace(/cart__\S+/g, ' ').replace(/\s+/g, ' ').trim();
        a.className = ('wishlist-header ' + cls).trim();
        cart.parentNode.insertBefore(a, cart);
      }
    });
  }

  function init() { injectHeader(); updateHearts(); updateCount(); renderAll(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-apply state when the grid changes (AJAX filters / pagination / quick view).
  var raf;
  var mo = new MutationObserver(function () {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = null; injectHeader(); updateHearts(); });
  });
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', function () { updateHearts(); updateCount(); renderAll(); });
})();
